module.exports = __webpack_public_path__ + "static/media/athena_docs.720808de.wav";